<template>
  <div style="padding-bottom:10px">
    <el-card shadow="always" :body-style="{ padding: '20px' }">
      <div slot="header">
        <el-row :gutter="20">
          <el-col :span="10" :offset="0">
            <el-button
              :type="status.color"
              :icon="status.icon"
              size="mini"
              circle
              disabled
            ></el-button>
            {{ source._id }}
          </el-col>
          <el-col :span="7" :offset="0">
            {{ $dayjs(source.date).format("DD.MM.YYYY HH:mm:ss") }}
          </el-col>
          <el-col :span="7" :offset="0">
            <div @click="showDetails">
              <el-tooltip
                v-if="source.resultMessage"
                :content="source.resultMessage"
                placement="top"
              >
                <span>{{ status.text }}</span>
              </el-tooltip>
              <span v-else>{{ status.text }}</span>
            </div>
          </el-col>
        </el-row>
      </div>
      <el-row :gutter="20">
        <el-col :span="8" :offset="0">
          <i class="el-icon-bottom"></i>
          <span>{{ from.amount }} {{ from.bestchangeKey }}</span>
        </el-col>
        <el-col :span="8" :offset="0">
          <i class="el-icon-top"></i>
          <span>{{ to.amount }} {{ to.bestchangeKey }}</span>
        </el-col>
        <el-col :span="8" :offset="0">
          <i class="el-icon-refresh"></i>
          <span>{{ rate.rate }} {{ rate.text }}</span>
        </el-col>
      </el-row>
      <div v-if="details && details.data && details.data.status">
        <el-divider direction="horizontal" content-position="left"></el-divider>
        <el-descriptions title="Данные оплаты" :column="4" size="mini" border>
          <template slot="extra">
            <el-button type="primary" size="mini" @click="details = null"
              >Скрыть</el-button
            >
            <el-button
              type="success"
              size="mini"
              @click="rawDetails = !rawDetails"
              >Все данные</el-button
            >
          </template>
          <el-descriptions-item>
            <template slot="label">
              status
            </template>
            {{ details.data.result.status }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              payment_at
            </template>
            {{
              details.data.result.payment_at &&
                details.data.result.payment_at.date
            }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              payment_id
            </template>
            {{ details.data.result.payment_id }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              ID
            </template>
            <el-tag size="small">{{ details.data.result.id }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              order_id
            </template>
            {{ details.data.result.order_id }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              amount
            </template>
            {{ details.data.result.amount }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              payment_amount
            </template>
            {{ details.data.result.payment_amount }}
          </el-descriptions-item>
        </el-descriptions>
        <div
          v-if="details && details.data && details.data.status && rawDetails"
        >
          <pre>{{ details.data.result }}</pre>
        </div>
        <!-- <el-divider direction="horizontal" content-position="left"></el-divider>

        <el-row :gutter="20">
          <el-col :span="8" :offset="0">
            status: {{ details.data.result.status }}
          </el-col>
          <el-col :span="8" :offset="0">
            <span v-if="details.data.result.payment_at">
              payment_at: {{ details.data.result.payment_at.date }}
            </span>
          </el-col>
          <el-col :span="8" :offset="0">
            payment_id: {{ details.data.result.payment_id }}
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="6" :offset="0">
            ID: {{ details.data.result.id }}
          </el-col>
          <el-col :span="6" :offset="0">
            order_id: {{ details.data.result.order_id }}
          </el-col>
          <el-col :span="6" :offset="0">
            amount: {{ details.data.result.amount }}
          </el-col>
          <el-col :span="6" :offset="0">
            payment_amount: {{ details.data.result.payment_amount }}
          </el-col>
        </el-row> -->
      </div>
    </el-card>
  </div>
</template>
<script>
import { getVanilaTransaction } from "@/api";
import statuses from "./statuses";
export default {
  name: "ApiUserTransactionComponent",
  props: {
    index: {
      type: Number
    },
    source: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      details: null,
      rawDetails: false
    };
  },
  computed: {
    from() {
      const amount = this.source.giveValute.forms.find(f => f.key === "count");
      return {
        bestchangeKey: this.source.giveValute.valute.bestchangeKey,
        amount: amount.value,
        title: this.source.giveValute.title
      };
    },
    to() {
      const amount = this.source.getValute.forms.find(f => f.key === "result");
      return {
        bestchangeKey: this.source.getValute.valute.bestchangeKey,
        amount: amount.value,
        title: this.source.getValute.title
      };
    },
    rate() {
      return {
        rate: (this.from.amount / this.to.amount).toFixed(2),
        text: `${this.from.bestchangeKey}/${this.to.bestchangeKey}`
      };
    },
    status() {
      // 0 - ожидание средств
      // 1 - в обработке
      // 2 - подтверждено
      // 3 - отклонено
      // 4 - отменено
      // 5 - ожидание фото для верификации
      // 6 - ожидание верификации модератором
      return statuses[+this.source.status] || statuses.default;
      // switch (+this.source.status) {
      //   case 0:
      //     return {
      //       text: "В ожидании средств",
      //       icon: "el-icon-circle-plus",
      //       color: "primary"
      //     };
      //   case 1:
      //     return {
      //       text: "В обработке",
      //       icon: "el-icon-warning",
      //       color: "warning"
      //     };
      //   case 2:
      //     return {
      //       text: "Подтверждена",
      //       icon: "el-icon-success",
      //       color: "success"
      //     };
      //   case 3:
      //     return {
      //       text: "Отклонена",
      //       icon: "el-icon-error",
      //       color: "danger"
      //     };
      //   case 4:
      //     return {
      //       text: "Отменена",
      //       icon: "el-icon-error",
      //       color: "danger"
      //     };
      //   case 5:
      //     return {
      //       text: "В ожидании фото для верификации",
      //       icon: "el-icon-warning",
      //       color: "warning"
      //     };
      //   case 2:
      //     return {
      //       text: "В ожидании верификации",
      //       icon: "el-icon-warning",
      //       color: "warning"
      //     };
      //   default:
      //     return {
      //       text: "Неизвестный статус",
      //       icon: "el-icon-warning",
      //       color: "info"
      //     };
      // }
    }
  },
  methods: {
    async showDetails() {
      try {
        this.details =
          this.source.paymentId &&
          (await getVanilaTransaction(this.source.paymentId));
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/pages/ApiUsers/Stats/transaction.vue